if (!customElements.get('xomd-video-dialog')) {
  customElements.define('xomd-video-dialog', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const dialog = this.querySelector('dialog');
      const video = this.querySelector('video');
      document.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link || link.getAttribute('href') !== this.dataset.trigger) return;
        event.preventDefault();
        this.trigger = link;
        dialog.showModal();
        video.play().catch(() => {});
      }, options);
      this.querySelector('button').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        video.pause();
        this.trigger?.focus();
      }, options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.querySelector('video')?.pause();
    }
  });
}
